import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {NbDatepickerModule, NbDialogModule, NbThemeModule, NbWindowModule,} from '@nebular/theme';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';
import {CoreModule} from '@core/core.module';
import {registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import * as fromSideMenu from '@app/redux/side-menu/side-menu.reducers';
import * as fromLoggedUser from '@app/redux/auth-user/auth-user.reducers';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {AuthUserEffects} from './redux/auth-user/auth-user.effects';
import {AppEffects} from './redux/app.effects';
import {WelfyContainerComponent} from '@feature-module/welfy-container/welfy-container.component';

registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [AppComponent, WelfyContainerComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NbDatepickerModule.forRoot(),
    NbThemeModule.forRoot({name: 'default'}),
    NbDialogModule.forRoot({
      closeOnBackdropClick: false,
      hasBackdrop: true,
      closeOnEsc: false,
    }),
    NbWindowModule.forRoot({
      hasBackdrop: false,
      closeOnBackdropClick: false,
      closeOnEsc: true,
    }),
    CoreModule,
    StoreModule.forRoot({menu: fromSideMenu.reducer, loggedUser: fromLoggedUser.reducer}),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: false}),
    EffectsModule.forRoot([AuthUserEffects, AppEffects]),
  ],
  providers: [{provide: LOCALE_ID, useValue: 'it-IT'}],
  bootstrap: [AppComponent],
})
export class AppModule {
}
